// 全局过滤器
// 获取文件名字
export const editFiles = src => {
  // return ;
  return src.substring(src.lastIndexOf("/") + 1, src.length);
};
export const ellipsis = value => {
  if (!value) return "";
  if (value.length > 15) {
    return value.slice(0, 15) + "...";
  }
  return value;
};

export const detailsEllipsis = value => {
  if (!value) return "";
  if (value.length > 10) {
    return value.slice(0, 10) + "...";
  }
  return value;
};


// WEBPACK FOOTER //
// ./src/filters/filters.js